import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { AuthProvider } from '@/auth/AuthProvider';
import { HttpError } from '@/api/errors';
import { UiProvider } from '@/ui';
import { MarketProvider } from './market';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Business errors and 4xx are final; retry only transient failures once.
      retry: (count, err) => count < 1 && !(err instanceof HttpError && err.status < 500),
    },
  },
});

/** Root: data cache, UI kit, session, working market, routes. */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UiProvider>
        <AuthProvider>
          <MarketProvider>
            <RouterProvider router={router} />
          </MarketProvider>
        </AuthProvider>
      </UiProvider>
    </QueryClientProvider>
  );
}
